import { RootState } from 'reduxStore/types';

export const getModerationRequestData = (state: RootState) =>
  state?.moderationRequest.moderationRequest;
